<template>
    <div>
        <router-link
            to="/"
            exact
            :activeClass="activeClass"
            :class="defaultClass"
        >
            Dashboard
        </router-link>
        <router-link
            v-if="group('patients')"
            to="/patients"
            :activeClass="activeClass"
            :class="defaultClass"
        >
            Pazienti
        </router-link>
        <router-link
            v-if="group('clients')"
            to="/clients"
            :activeClass="activeClass"
            :class="defaultClass"
        >
            Aziende
        </router-link>
        <router-link
            v-if="group('calendar')"
            to="/calendar"
            :activeClass="activeClass"
            :class="defaultClass"
        >
            Calendario
        </router-link>
        <router-link
            v-if="group('documents')"
            to="/documents"
            :activeClass="activeClass"
            :class="defaultClass"
        >
            Documenti
        </router-link>
        <router-link
            v-if="group('documents')"
            to="/invoices"
            :activeClass="activeClass"
            :class="defaultClass"
        >
            Export Fatture
        </router-link>
    </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";

export default {
    props: {
        defaultClass: {
            type: String,
            default:
                "px-3 py-2 ml-4 text-sm font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700",
        },
        activeClass: {
            type: String,
            default:
                "bg-gray-900 focus:outline-none focus:text-white focus:bg-gray-700",
        },
    },
    computed: {
        ...mapState("app", ["user"]),
    },
    methods: {
        ...mapGetters("app", ["group"]),
    },
};
</script>
